import { useMemo } from "react";

import { type WorkScheduleProfile } from "../../../../lib/api/policies";
import { t } from "../../../../lib/i18n";

interface SchedulesKpiStripProps {
  rows: WorkScheduleProfile[];
}

interface StatTile {
  label: string;
  value: number;
}

export function SchedulesKpiStrip({ rows }: SchedulesKpiStripProps) {
  const tiles = useMemo<StatTile[]>(() => {
    const total = rows.length;
    const active = rows.filter((r) => r.is_active).length;
    const assigned = rows.filter((r) => r.assignments_count > 0).length;
    const enforcing = rows.filter((r) => r.is_currently_enforcing).length;
    return [
      { label: t("schedules.kpi.total"), value: total },
      { label: t("schedules.kpi.active"), value: active },
      { label: t("schedules.kpi.withAssignments"), value: assigned },
      { label: t("schedules.kpi.inOffHoursNow"), value: enforcing },
    ];
  }, [rows]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        gap: 12,
      }}
    >
      {tiles.map((tile) => (
        <div
          key={tile.label}
          style={{
            padding: "12px 16px",
            border: "1px solid var(--color-border)",
            borderRadius: 8,
            background: "var(--color-surface)",
          }}
        >
          <div
            style={{
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              color: "var(--color-text-muted)",
            }}
          >
            {tile.label}
          </div>
          <div style={{ fontSize: 24, fontWeight: 600, marginTop: 4 }}>
            {tile.value}
          </div>
        </div>
      ))}
    </div>
  );
}
